import { useAppSelector } from "../../stateManagement/hooks/redux";
import Breadcrumbs from "./breadcrumbs/Breadcrumbs";
import MenuList from "./menuList/MenuList";
import SelectedPathDisplay from "./selectedPathDisplay/SelectedPathDisplay";

export default function Sidebar() {

    const currentMenuPath = useAppSelector(state => state.sidebar.sidebarMenuPath)
    const notAtStartNode = currentMenuPath.length > 0

    return (
        <div className="sidebar-div">
            <SelectedPathDisplay />
            {notAtStartNode && <Breadcrumbs />}
            <MenuList />
        </div>
    )
}
